import React, { useState, useEffect, useCallback } from 'react';
import { FiPlus, FiEdit2, FiTrash2, FiX, FiSearch } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const emptyForm = { judul: '', ringkasan: '', konten: '', kategori: 'umum', tags: '', gambar: '' };

const DashboardBerita = () => {
  const [berita, setBerita] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);
  const [search, setSearch] = useState('');
  const [filterKat, setFilterKat] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try { 
      const params = { limit: 50 };
      if (search) params.search = search;
      if (filterKat) params.kategori = filterKat;
      const res = await api.get('/berita', { params }); 
      setBerita(res.data.data); 
    } catch (e) { 
      toast.error('Gagal memuat berita'); 
    } finally { 
      setLoading(false); 
    }
  }, [search, filterKat]);

  useEffect(() => { load(); }, [load]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = { ...form, tags: form.tags ? form.tags.split(',').map(t => t.trim()) : [] };
      if (editId) { await api.put(`/berita/${editId}`, data); toast.success('Berita diperbarui'); }
      else { await api.post('/berita', data); toast.success('Berita dibuat'); }
      setShowModal(false); setEditId(null); setForm(emptyForm); load();
    } catch (e) { toast.error(e.response?.data?.message || 'Gagal menyimpan'); }
  };

  const handleEdit = (b) => {
    setEditId(b._id);
    setForm({ judul: b.judul, ringkasan: b.ringkasan, konten: b.konten, kategori: b.kategori, tags: b.tags?.join(', ') || '', gambar: b.gambar || '' });
    setShowModal(true);
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    const uploadToast = toast.loading('Mengunggah gambar...');
    try {
      const res = await api.post('/upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setForm({ ...form, gambar: res.data.fileUrl });
      toast.success('Gambar berhasil diunggah', { id: uploadToast });
    } catch (e) {
      toast.error('Gagal mengunggah gambar', { id: uploadToast });
    }
  };

  const handleDelete = async (id, judul) => {
    if (!window.confirm(`Hapus berita "${judul}"?`)) return;
    try { await api.delete(`/berita/${id}`); toast.success('Berita dihapus'); load(); } catch (e) { toast.error('Gagal menghapus'); }
  };

  return (
    <div>
      <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div><h2>Kelola Berita</h2><p>{berita.length} berita</p></div>
        <button className="btn btn-primary" onClick={() => { setEditId(null); setForm(emptyForm); setShowModal(true); }}><FiPlus /> Tambah Berita</button>
      </div>

      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', flex: 1, minWidth: 250 }}>
          <div style={{ position: 'relative', width: '100%' }}>
            <FiSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--gray-400)' }} />
            <input className="form-input" placeholder="Cari berita..." value={search} onChange={(e) => setSearch(e.target.value)} style={{ paddingLeft: '35px' }} />
          </div>
        </div>
        <select className="form-select" style={{ width: 180 }} value={filterKat} onChange={(e) => setFilterKat(e.target.value)}>
          <option value="">Semua Kategori</option>
          <option value="umum">Umum</option>
          <option value="program">Program</option>
          <option value="kegiatan">Kegiatan</option>
          <option value="pengumuman">Pengumuman</option>
        </select>
      </div>
      {loading ? <div className="loading-spinner"><div className="spinner" /></div> : (
        <div className="table-container">
          <table className="data-table">
            <thead><tr><th>Judul</th><th>Kategori</th><th>Views</th><th>Tanggal</th><th>Aksi</th></tr></thead>
            <tbody>
              {berita.map(b => (
                <tr key={b._id}>
                  <td><strong style={{ fontSize: '0.85rem' }}>{b.judul}</strong></td>
                  <td><span className="badge badge-info">{b.kategori}</span></td>
                  <td>{b.viewCount || 0}</td>
                  <td style={{ fontSize: '0.8rem', color: 'var(--gray-400)' }}>{new Date(b.createdAt).toLocaleDateString('id-ID')}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button className="btn btn-ghost btn-sm btn-icon" onClick={() => handleEdit(b)}><FiEdit2 size={14} /></button>
                      <button className="btn btn-ghost btn-sm btn-icon" onClick={() => handleDelete(b._id, b.judul)} style={{ color: 'var(--danger)' }}><FiTrash2 size={14} /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {berita.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--gray-400)', padding: '2rem' }}>Tidak ada berita</td></tr>}
            </tbody>
          </table>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 640 }}>
            <div className="modal-header">
              <h3 style={{ fontFamily: 'var(--font-body)', fontSize: '1.1rem' }}>{editId ? 'Edit Berita' : 'Tambah Berita'}</h3>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}><FiX /></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Judul *</label><input className="form-input" value={form.judul} onChange={(e) => setForm({...form, judul: e.target.value})} required /></div>
                <div className="form-group"><label className="form-label">Ringkasan *</label><textarea className="form-textarea" style={{ minHeight: 80 }} value={form.ringkasan} onChange={(e) => setForm({...form, ringkasan: e.target.value})} required /></div>
                <div className="form-group"><label className="form-label">Konten Lengkap *</label><textarea className="form-textarea" style={{ minHeight: 160 }} value={form.konten} onChange={(e) => setForm({...form, konten: e.target.value})} required /></div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
                  <div className="form-group">
                    <label className="form-label">Kategori</label>
                    <select className="form-select" value={form.kategori} onChange={(e) => setForm({...form, kategori: e.target.value})}>
                      <option value="umum">Umum</option><option value="program">Program</option><option value="kegiatan">Kegiatan</option><option value="pengumuman">Pengumuman</option>
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Tags</label><input className="form-input" value={form.tags} onChange={(e) => setForm({...form, tags: e.target.value})} placeholder="pisahkan, dengan, koma" /></div>
                </div>
                <div className="form-group" style={{ marginTop: '1rem' }}>
                  <label className="form-label">Foto Berita</label>
                  <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
                    {form.gambar && (
                      <div style={{ width: 60, height: 60, borderRadius: 8, overflow: 'hidden', border: '1px solid var(--gray-100)' }}>
                        <img src={form.gambar} alt="Thumbnail" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      </div>
                    )}
                    <input type="file" accept="image/*" onChange={handleFileUpload} style={{ fontSize: '0.8rem' }} />
                  </div>
                  {form.gambar && <div style={{ fontSize: '0.7rem', color: 'var(--gray-400)', marginTop: '0.25rem' }}>{form.gambar}</div>}
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-ghost" onClick={() => setShowModal(false)}>Batal</button>
                <button type="submit" className="btn btn-primary">{editId ? 'Simpan' : 'Buat Berita'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardBerita;
